import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","flex-direction":"row","justify-content":"space-between"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"display":"flex","align-items":"center"} }, " Face Preload "),
    /*#__PURE__*/_createElementVNode("span", { style: {"display":"flex","align-items":"center","margin":"5px 0 0 10px","font-size":"8px"} })
  ])
], -1)
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { style: {"flex":"1"} }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("img", {
        src: _ctx.src,
        style: {"width":"30%","min-height":"200px","object-fit":"contain","border-radius":"10px"}
      }, null, 8, _hoisted_2), [
        [_vShow, _ctx.src]
      ])
    ]),
    _: 1
  }))
}